// src/components/AdminRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

function AdminRoute({ element }) {
  const { user, status } = useSelector((state) => state.user);

  if (status === "loading" || user === undefined) {
    return <LoadingSpinner message="Checking admin access..." />; 
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user needs onboarding
  if (user.organization && user.organization.onboarding && !user.organization.onboarding.isCompleted) {
    const currentStep = user.organization.onboarding.currentStep || 'welcome';
    return <Navigate to={`/onboarding/${currentStep}`} replace />;
  }

  // Check if user is admin in their organization
  const isOrgAdmin = () => {
    if (!user || !user.organization || !user.organization.users) {
      return false;
    }
    const entry = user.organization.users.find(
      (e) => e.user && e.user._id && e.user._id === user._id
    );
    return entry ? entry.role === "admin" : false;
  };

  if (!isOrgAdmin()) {
    return <Navigate to="/" replace />;
  }

  return element;
}

export default AdminRoute;
